import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/harapan-jaya.png'


const _hoisted_1 = { class: "login background-grey-lighten-5 w-100 h-100 pb-16 relative" }
const _hoisted_2 = { class: "flex card bg-white items-center" }
const _hoisted_3 = { class: "form lg:w-1/2 md:w-full sm:w-full flex flex-col justify-between" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field mb-6" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "py-3" }

import {
  ref,
  onMounted,
  getCurrentInstance,
  reactive
} from 'vue'
import Button from 'primevue/button'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
// import InputText from 'primevue/inputtext'
import { useRouter, useRoute } from 'vue-router'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import ProgressSpinner from 'primevue/progressspinner'
import { authUseCase } from '@/usecase'
import { useStore } from 'vuex'
import moment from 'moment'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import environment from '@/configs/environtment'

import SwitchMenu from '@/views/components/switch/SwitchMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginHjex',
  setup(__props) {

const loading = ref(false)
const router = useRouter()
const store = useStore()
const route = useRoute()
const dataForm = ref()
const loginChallenge = ref()

const schema = Yup.object().shape({
  username: Yup.string().required('Username harus diisi'),
  password: Yup.string().required('Password harus diisi')
})

const initialValues = {
  username: '',
  password: ''
}

const loginProcess = async () => {
  const sendLoginChallenge = await authUseCase.sendingHjexLoginChallenge(route.query.login_challenge, dataForm.value.username, dataForm.value.password)
  console.log(sendLoginChallenge)
  if (!sendLoginChallenge.error) {
    console.log('res', sendLoginChallenge.data)
    window.location.href = sendLoginChallenge.data.RedirectTo
    store.dispatch('setIsAuthenAuthenticated', true)
    store.dispatch('setDateAuthenAuthenticated', moment().format())
    store.dispatch('setUserAndPass', { username: dataForm.value.username, password: dataForm.value.password })
  } else {
    console.log('uhhhh')
    loading.value = false
  }
}

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  dataForm.value = {
    username: values.username,
    password: values.password
  }
  loading.value = true
  loginProcess()
}

const toPage = (val: any) => {
  router.push({
    name: val
  })
}

const handleChange = () => {
  console.log('change')
}

const handleBlur = () => {
  console.log('blur')
}

const valueSwitch = ref(0)
const listSwitchMenu = ref([
  { key: 0, label: 'HJP' },
  { key: 1, label: 'HJeX' },
])

const changePosition = (val: any) => {
  valueSwitch.value = val.key
}

const toLoginHjp = () => {
  localStorage.setItem('auth', '0')
  toPage('Home')
}

onMounted(() => {
  loginChallenge.value = route.query.login_challenge
  // store.dispatch('setLoginChallenge', loginChallenge.value)
  localStorage.setItem('challenge', loginChallenge.value)
  localStorage.removeItem('auth')
  // localStorage.removeItem('challenge')
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "lg:hidden md:block sm:block px-10 py-16 top-info" }, [
      _createElementVNode("h3", { class: "text-white font-bold" }, "Bus & Penumpang"),
      _createElementVNode("p", { class: "text-lg text-white" }, "Bus Schedules & Logistic Management System")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "image-left lg:w-1/2 lg:block md:hidden sm:hidden relative" }, [
        _createElementVNode("div", { class: "info absolute px-6 py-3" }, [
          _createElementVNode("h3", { class: "text-white" }, "Bus & Penumpang"),
          _createElementVNode("p", { class: "text-white" }, "Bus Schedules & Logistic Management System")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: _imports_0,
            class: "h-10 mx-auto",
            alt: "logo"
          }, null, -1)),
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(schema),
            "initial-values": initialValues,
            class: "p-16 pt-5 w-full"
          }, {
            default: _withCtx(({ errors, setFieldValue, values }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { for: "username" }, "Username", -1)),
                  _createVNode(_unref(Field), { name: "username" }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createVNode(_unref(InputText), {
                        onChange: handleChange,
                        onBlur: handleBlur,
                        autofocus: "",
                        class: _normalizeClass(`input-primary`),
                        placeholder: "Ex. john@username.com",
                        modelValue: values.username,
                        "onUpdate:modelValue": ($event: any) => ((values.username) = $event)
                      }, null, 8, ["onChange", "onBlur", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(errors.username), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { for: "password" }, "Password", -1)),
                  _createVNode(_unref(Field), {
                    name: "password",
                    onChange: handleChange,
                    onBlur: handleBlur
                  }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createVNode(_unref(Password), {
                        autofocus: "",
                        feedback: false,
                        placeholder: "********",
                        modelValue: values.password,
                        "onUpdate:modelValue": ($event: any) => ((values.password) = $event),
                        toggleMask: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(errors.password), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", {
                  class: "link-orange cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage('forgot-password')))
                }, "Lupa Password")
              ]),
              _createVNode(_unref(Button), {
                class: "btn-orange",
                id: "submit-login",
                disabled: loading.value,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                        key: 0,
                        strokeWidth: "8",
                        fill: "white"
                      }))
                    : _createCommentVNode("", true),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mx-auto font-bold text-white" }, "Masuk", -1))
                ]),
                _: 1,
                __: [3]
              }, 8, ["disabled"]),
              _createVNode(_unref(Button), {
                class: "btn-primary mt-4",
                disabled: loading.value,
                onClick: toLoginHjp
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("span", { class: "mx-auto font-bold text-white" }, "Masuk dengan akun HJP", -1)
                ])),
                _: 1,
                __: [4]
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-center color-blue-grey font-semibold text-xs" }, _toDisplayString('Version 1.0.0'), -1))
      ])
    ])
  ]))
}
}

})